module.exports = __webpack_public_path__ + "static/media/z&v8.0701b7ec.jpg";